import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from './moment'

/**
 * Create a React Day Picker Stepper Label component
 *
 * @param {import('./interfaces').DayPickerStepperLabelProps} props
 * @returns {JSX.Element}
 */
export default function DayPickerStepperLabel (props) {
  const { date, onYearClick, onMonthClick } = props
  const momentDate = moment(date)
  const selectedMonth = moment.localeData().monthsShort()[momentDate.month()]
  const selectedYear = momentDate.year()
  return (
    <Fragment>
      <button
        type='button'
        className='zb-button-link pika-label'
        onClick={onMonthClick}
        aria-label={`Change month selected ${selectedMonth}`}
      >
        {selectedMonth}
      </button>{' '}
      <button
        type='button'
        className='zb-button-link pika-label'
        onClick={onYearClick}
        aria-label={`Change year selected ${selectedYear}`}
      >
        {selectedYear}
      </button>
    </Fragment>
  )
}

DayPickerStepperLabel.propTypes = {
  date: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.number,
    PropTypes.instanceOf(moment)
  ]),
  onYearClick: PropTypes.func,
  onMonthClick: PropTypes.func
}
